var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxGap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.3114 3.98666C10.85 3.86444 11.1876 3.32876 11.0654 2.79016C10.9431 2.25157 10.4075 1.91403 9.86886 2.03624C5.37025 3.05703 2.01129 7.07871 2.01129 11.8873C2.01129 17.4662 6.53384 21.9887 12.1127 21.9887C16.9213 21.9887 20.943 18.6297 21.9638 14.1311C22.086 13.5925 21.7484 13.0568 21.2098 12.9346C20.6712 12.8124 20.1355 13.15 20.0133 13.6886C19.1947 17.2962 15.9669 19.9887 12.1127 19.9887C7.63841 19.9887 4.01129 16.3616 4.01129 11.8873C4.01129 8.03305 6.70379 4.80528 10.3114 3.98666Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7271 2.13012C14.4709 2.06147 14.198 2.09741 13.9683 2.23002C13.7386 2.36263 13.571 2.58105 13.5024 2.83722L11.1468 11.6285C11.0543 11.9736 11.1529 12.3418 11.4056 12.5944C11.6582 12.847 12.0264 12.9457 12.3715 12.8532L21.1628 10.4976C21.4189 10.429 21.6374 10.2614 21.77 10.0317C21.9026 9.80202 21.9385 9.52906 21.8699 9.27288C21.4109 7.56014 20.5093 5.99837 19.2554 4.74455C18.0016 3.49073 16.4399 2.58905 14.7271 2.13012ZM13.5269 10.4731L15.1594 4.38063C16.1601 4.78679 17.0728 5.39031 17.8412 6.15876C18.6097 6.92721 19.2132 7.8399 19.6194 8.84063L13.5269 10.4731Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxGap);
export default __webpack_public_path__ + "static/media/tax-gap.5f411b00.svg";
export { ForwardRef as ReactComponent };